<template>
  <router-view />
</template>

<script>
export default {
  computed: {
    hideSidebar() {
      return this.$route.meta.hideNavbar === true;
    },
  },
};
</script>

<style>
@import url("@/assets/Css/Root.css");
@import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Arabic:wght@100;200;300;400;500;600;700&display=swap");

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  background-color: var(--background-color);
}
#app {
  font-family: var(--font-family);
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
